import styled from 'styled-components'
import { spacingSM } from 'Utils/styles/spacing'
import { zirconGray } from 'Utils/styles/colors'

const Banner = styled.div`
  margin-bottom: ${spacingSM};
  padding: ${spacingSM};
  background-color: ${zirconGray};
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: ${spacingSM};
`

const Stat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const StatLabel = styled.div`
  font-size: 12px;
  color: #666;
  margin-bottom: 2px;
`

const StatValue = styled.div`
  font-size: 18px;
  font-weight: 600;
`

type SummaryBannerProps = {
  summary: {
    total_csv_rows: number
    new_users_count: number
    updated_users_count: number
    removed_users_count: number
    unchanged_users_count: number
    total_changes: number
  }
}

export const SummaryBanner = ({ summary }: SummaryBannerProps) => {
  return (
    <Banner>
      <Stat>
        <StatLabel>Users in CSV</StatLabel>
        <StatValue>{summary.total_csv_rows}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>New Users</StatLabel>
        <StatValue>{summary.new_users_count}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>Updates</StatLabel>
        <StatValue>{summary.updated_users_count}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>Removals</StatLabel>
        <StatValue>{summary.removed_users_count}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>Unchanged</StatLabel>
        <StatValue>{summary.unchanged_users_count}</StatValue>
      </Stat>
      <Stat>
        <StatLabel>Total Changes</StatLabel>
        <StatValue>{summary.total_changes}</StatValue>
      </Stat>
    </Banner>
  )
}
